export default __webpack_public_path__ + "media/content-comms.75523b4765f0315bd0ae94f0923c1d28.svg";